import { Empty } from 'antd'
import type { EmptyProps } from 'antd'

// Wrapper Empty: bọc AntD Empty để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Pass-through, không thêm hành vi.
export default function UiEmpty(props: EmptyProps) {
  return <Empty {...props} />
}

UiEmpty.PRESENTED_IMAGE_DEFAULT = Empty.PRESENTED_IMAGE_DEFAULT
UiEmpty.PRESENTED_IMAGE_SIMPLE = Empty.PRESENTED_IMAGE_SIMPLE
